import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import GenericButton from '../GenericButton/GenericButton';

const MainButton: React.FC<{
	label: string;
	onClick: (e: React.MouseEvent<HTMLButtonElement>) => void | Promise<void>;
	size?: 'sm' | 'md' | 'lg';
	icon?: IconProp;
	disabled?: boolean;
	invert?: boolean;
	fullWidth?: boolean;
	hideIcon?: boolean;
	forceShowLabel?: boolean;
}> = (props) => <GenericButton {...props} variant="main" />;

export default MainButton;
